// The day as the file name carries it: 2026-10-26
const dayOf = (date: Date): string => {
  const pad = (value: number): string => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

// The name of an exported file: the non-empty parts, each cut down to
// letters, digits, "_" and "-", then the day: matrix-makers-modes-2026-10-26.xlsx
export const exportFilename = (
  parts: readonly (string | null | undefined)[],
  ext: string,
  date: Date = new Date(),
): string => {
  const stem = parts
    .map((part) =>
      (part ?? "")
        .replace(/[^A-Za-z0-9_-]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .toLowerCase(),
    )
    .filter((part) => part !== "")
    .join("-");
  return `${[stem, dayOf(date)].filter(Boolean).join("-")}.${ext}`;
};
